
export default function alterTree(tree, key, value) {

    const keys = Array.isArray(key) ? key :
        typeof key === "string" ? key.split(".") :
            null;

    if (keys === null || keys.length === 0) {
        return {...tree};
    }

    function alter(tree, keys, value) {
        if(keys.length === 0 ) return value;
        const [k, ...ks] = keys;        
        tree[k] = alter(
            Array.isArray(tree[k]) ? 
                [...tree[k]] : 
                {...tree[k]}, 
            ks, 
            value);
        return tree;
    }

    return alter({...tree}, keys, value);
}

